import React, { useState, useEffect, useContext } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import i18n from '../i18n';
import Spinner from '../components/Spinner';
import FirebaseContext from '../services/firebase/context';

const PrivateRoute = () => {
  const firebase = useContext(FirebaseContext);
  const [authReady, setAuthReady] = useState(false);
  const [firebaseUser, setFirebaseUser] = useState(null);

  useEffect(() => {
    if (!firebase?.auth) {
      return undefined;
    }

    const unsubscribe = firebase.auth.onAuthStateChanged(user => {
      setFirebaseUser(user);
      setAuthReady(true);
    });

    return unsubscribe;
  }, [firebase]);

  if (!authReady) {
    return <Spinner />;
  }

  if (!firebaseUser) {
    const redirectPath = i18n.language === 'en' ? '/signin' : `/${i18n.language}/signin`;
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
